
import { defineComponent } from 'vue'
import { iLibrary } from '../../../../FunctionsCatalog'
import { filterDefault } from '@/helpers/commons/filterHelper'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import functionsCatalogDatasetEnvironmentTableDescriptor from './FunctionsCatalogDatasetEnvironmentTableDescriptor.json'

export default defineComponent({
    name: 'function-catalog-dataset-environment-table',
    components: { Column, DataTable },
    props: { libraries: { type: Array } },
    data() {
        return {
            functionsCatalogDatasetEnvironmentTableDescriptor,
            filters: { global: [filterDefault] } as Object,
            environmentLibraries: [] as iLibrary[]
        }
    },
    watch: {
        libraries() {
            this.loadLibraries()
        }
    },
    created() {
        this.loadLibraries()
    },
    methods: {
        loadLibraries() {
            this.environmentLibraries = this.libraries as iLibrary[]
        }
    }
})
